import React from "react";
import { BriefcaseIcon, TrashIcon, PlusCircleIcon, NoSymbolIcon, PencilSquareIcon } from "@heroicons/react/24/outline";
import SvgBreak from "./svg_break";
import Tooltip from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';

const CustomTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))({
'& .MuiTooltip-tooltip': {
    backgroundColor: '#a3a3a3',
    color: '#FFFFFF',
    fontSize: '0.8rem',
},
});


export default function ShiftCard({ workingHour, handleDeleteDailyWh, dipendente, formattedDay, selectedUnit, handlePlusCircleClick, handleEditOuPairing, handleConfirmSingleShift, dayBlocked }) {
    if (!workingHour) return null;

    const isFisso = workingHour.typology === 'fisso';

    return (
        <div className="rounded-lg bg-white shadow">
            {workingHour.typology === "senza_calendario" ? (
                <div className="text-center text-xs text-gray-700"></div>
            ) : Array.isArray(workingHour?.shifts) && workingHour.shifts.length > 0 ? (
                <>
                    {workingHour.shifts
                    .sort((a, b) => {
                        const aStart = a.time_slots && a.time_slots[0] ? new Date(a.time_slots[0].start_at) : new Date();
                        const bStart = b.time_slots && b.time_slots[0] ? new Date(b.time_slots[0].start_at) : new Date();
                        return aStart - bStart;
                    })
                    .map((shift, shiftIndex) => {
                        const belongsToSelectedUnit = shift.ref_ou === selectedUnit;

                        return (
                            <div
                                key={shiftIndex}
                                className={`mb-3 py-2 border rounded-lg flex flex-col justify-between 
                                    ${isFisso ? "h-[180px]" : "h-[260px]"} 
                                    ${isFisso ? "border-indigo-500" : (shift.status ? "border-indigo-500" : "border-orange-400")}
                                `}
                            >
                                {/* Header - Nome turno */}
                                <div
                                    className={`text-xs uppercase px-1 font-normal pt-1 mb-1  ${
                                        selectedUnit
                                            ? belongsToSelectedUnit
                                                ? "bg-transparent"
                                                : "bg-gray-200 rounded-md mx-1"
                                            : "bg-transparent"
                                    }`}
                                    style={{ wordBreak: 'break-word', whiteSpace: 'normal', overflowWrap: 'break-word' }}
                                >
                                    {shift.ref_name || "Fascia oraria"}
                                </div>

                                {/* Time Slots */}
                                <div className="flex-grow p-2 border-t" style={{ overflowY: 'auto' }}>
                                    {Array.isArray(shift?.time_slots) && shift.time_slots.length > 0 ? (
                                        shift.time_slots
                                        .sort((a, b) => new Date(a.start_at) - new Date(b.start_at))
                                        .map((slot, slotIndex) => (
                                            <div key={slotIndex} className="mb-2">
                                                <div className={`text-xs font-semibold text-gray-900 rounded-md p-1  ${isFisso ? "bg-indigo-100" : (shift.status ? "bg-indigo-100" : "bg-orange-100")}`}>
                                               
                                                    <BriefcaseIcon className="inline-block w-3 h-3 mr-1" />
                                                    {slot.start_at} - {slot.end_at}
                                                </div>
                                                {Array.isArray(slot.breaks) && slot.breaks.length > 0 && (
                                                    <div className="mt-1 text-xs text-gray-600">
                                                        {slot.breaks.map((breakTime, breakIndex) => (
                                                            <div key={breakIndex} className="flex items-center justify-start">
                                                                <span className="ml-2">
                                                                    <SvgBreak className="inline-block w-3 h-3 mr-1" />
                                                                    {breakTime.start_at} - {breakTime.end_at}
                                                                </span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        ))
                                    ) : (
                                        <p className="text-xs text-gray-500">Nessun orario disponibile</p>
                                    )}
                                </div>

                                {/* Footer - Trash Icon & Status */}
                                <div className="flex flex-col items-center px-1">
                                    {!isFisso && (
                                        (() => {
                                            const showButtons = !selectedUnit || shift?.ref_ou === selectedUnit;
                                            return (
                                                <>
                                                    {showButtons && (
                                                        <div className="border-y border-gray-200 w-full flex justify-center gap-3 py-1">
                                                            {shift.typology === 'custom' && (
                                                                <CustomTooltip title="Modifica Unità" placement="top-start">
                                                                    <PencilSquareIcon
                                                                        className='text-gray-900 hover:text-blue-600 cursor-pointer w-5 h-5'
                                                                        onClick={(e) => {
                                                                            if (dayBlocked) {
                                                                                e.preventDefault();
                                                                                return;
                                                                            }
                                                                            handleEditOuPairing(dipendente.id, shift);
                                                                        }}
                                                                    />
                                                                </CustomTooltip>
                                                            )}
                                                            <CustomTooltip title="Elimina turno" placement="top-start">
                                                                <TrashIcon
                                                                    className="text-gray-900 hover:text-red-600 cursor-pointer w-5 h-5"
                                                                    onClick={() =>
                                                                        handleDeleteDailyWh(
                                                                            dipendente.id,
                                                                            shift.dailyWorkingHourId,
                                                                            dipendente.cf,
                                                                            formattedDay,
                                                                            dipendente.last_name || "",
                                                                            dipendente.first_name || "",
                                                                            shift.status, 
                                                                            shift?.ref_ou
                                                                        )
                                                                    }
                                                                />
                                                            </CustomTooltip>
                                                        </div>
                                                    )}
                                                </>
                                            );
                                        })()
                                    )}
                                    {isFisso ? (
                                        <div className='text-xs font-semibold mt-2 text-indigo-600'>
                                            Turno fisso
                                        </div>
                                    ) : (
                                        <>
                                            <div className={`text-xs font-semibold mt-2 ${shift.status ? "text-indigo-600" : "text-orange-500"}`}>
                                                {shift.status ? "Confermato" : "Attesa conferma"}
                                            </div>
                                            {!shift.status && (
                                                <button 
                                                    className="py-1 bg-orange-400 w-full text-white uppercase rounded-md mt-1 shadow-lg"
                                                    onClick={(e) => {
                                                        if (dayBlocked) {
                                                            e.preventDefault();
                                                            return;
                                                        } 
                                                        handleConfirmSingleShift(dipendente, shift.dailyWorkingHourId);
                                                    }}
                                                >
                                                    Conferma
                                                </button>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </>
            ) : (
                <div className="absolute top-0 left-0 right-0 bottom-0 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity duration-300">
                    {(workingHour?.week_hours && workingHour?.has_active_contract) || (workingHour.shift_type === 'a_chiamata' && workingHour?.has_active_contract) ? (
                        <PlusCircleIcon
                            className="text-indigo-500 hover:bg-indigo-50 rounded-2xl hover:text-indigo-500 cursor-pointer w-10 h-10"
                            onClick={() =>
                                handlePlusCircleClick(
                                    dipendente.id,
                                    formattedDay,
                                    dipendente.cf,
                                    dipendente.last_name || '',
                                    dipendente.first_name || '',
                                    selectedUnit || ''
                                )
                            }
                        />
                    ) : (
                        <div className="absolute top-0 left-0 right-0 bottom-0 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity duration-300">
                            <div className="flex flex-col items-center justify-center text-gray-500">
                                <NoSymbolIcon className="w-8 h-8 text-red-500 mb-2" />
                                <p>Orario lavorativo non presente</p>
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}

  